import type { ScheduleEmployeesOrder } from "@/pages/human-resources/time-management/model/ScheduleEmployeesOrder.ts";
import {
  mapFromEmployeeOrder,
  mapFromGroupedArrangement,
  type PrintSortTypeIn,
} from "@/pages/human-resources/time-management/endpoints/schedules/print/inout/PrintSortTypeIn.ts";
import type { ScheduleViewGroupByArrangement } from "@/pages/human-resources/time-management/model/ScheduleViewArrangement.ts";

export interface PrintSortIn {
  sortType: PrintSortTypeIn;
  reversed: boolean;
}

export function mapFromScheduleOrder(seo: ScheduleEmployeesOrder): PrintSortIn {
  return {
    sortType: mapFromEmployeeOrder(seo.order),
    reversed: seo.reversed,
  };
}

export function mapFromArrangement(
  svgba: ScheduleViewGroupByArrangement,
): PrintSortIn {
  return {
    sortType: mapFromGroupedArrangement(svgba),
    reversed: false,
  };
}
